<template>
  <b-modal ref="searchResultFilterModal"
           centered
           title="Filtr wyników wyszukiwania"
           :visible="searchResultFilterVisible"
           @hidden="hide"
           @show="onShow">
    <b-form>
      <fieldset>
        <b-form-group v-for="(values, column) in distinctColumnValues" :key="column">
          <b-form-row>
            <b-col md="3" offset-md="1">
              <label class="col-form-label" :for="column">{{ column }}</label>
            </b-col>
            <b-col md="5">
              <b-form-select :id="column" v-model="selected[column]">
                <option value="">Dowolny</option>
                <option v-for="value in values" :key="value" :value="value">{{ value }}</option>
              </b-form-select>
            </b-col>
          </b-form-row>
        </b-form-group>
      </fieldset>
    </b-form>
    <div slot="modal-footer">
      <b-btn variant="primary" @click="applyFilters">Zastosuj filtr</b-btn>
      <b-btn variant="danger" @click="clearFilter">Wyczyść filtry</b-btn>
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import {SET_APPLIED_FILTERS, WINDOW_SEARCH_RESULT_FILTER_HIDE} from "../store/mutations.type";

export default {
  name: "searchResultFilterWindow",
  data: function() {
    return {
      selected: {},
    };
  },
  watch: {
    selected: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["searchResultFilterVisible", "distinctColumnValues", "appliedSearchResultFilters"]),
  },
  methods: {
    applyFilters(){
      this.$store.commit(SET_APPLIED_FILTERS, this.selected);
      this.$emit('filterApplied', this.selected);
      this.hide();
    },
    clearFilter(){
      for(let column in this.distinctColumnValues) {
        this.$set(this.selected, column, "");
      }
    },
    hide() {
      this.$store.commit(WINDOW_SEARCH_RESULT_FILTER_HIDE);
    },
    onShow() {
      for(let column in this.distinctColumnValues) {
        this.$set(this.selected, column, this.appliedSearchResultFilters[column] || "");
      }
    }
  },
};
</script>
